import React, { FC } from "react";

interface Shape1Props {
  className: string;
}

const Shape1: FC<Shape1Props> = ({ className }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 300 300"
      focusable="false"
      aria-hidden="true"
      role="img"
    >
      <circle
        cx="198"
        cy="425"
        r="150"
        fill="currentColor"
        fillRule="evenodd"
        transform="translate(-48 -275)"
      ></circle>
    </svg>
  );
};

export default Shape1;
